// extracted by mini-css-extract-plugin
var _1 = "ik2_LNWL2WPDnMRhCvIK";
export { _1 as "confirmationModal" }
